import { render } from "./TrendingOriginators.vue?vue&type=template&id=49a36cd0"
import script from "./TrendingOriginators.vue?vue&type=script&lang=js"
export * from "./TrendingOriginators.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__